module.exports = __webpack_public_path__ + "img/http-collapse-icon.115da2b4.svg";